import React from "react"

function CTAA() {
  return (
    <svg fill="none" viewBox="0 0 266 150">
      <path fill="var(--solid)" d="M0 0h266v150H0z" />
      <rect
        x={20}
        y={68}
        width={119}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect
        x={20}
        y={77}
        width={92}
        height={5}
        rx={2.5}
        fill="var(--solid-900)"
      />
      <rect
        x={206}
        y={70}
        width={40}
        height={10}
        rx={2}
        fill="var(--main-500)"
      />
    </svg>
  )
}

export default CTAA;
